import { IndexaPlansSummaryResponse } from './types';

export default async function getIndexaPlansSummary(
	token: string
): Promise<IndexaPlansSummaryResponse> {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/thirdparty/indexa/plans-summary`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			}
		}
	);

	if (!response.ok) {
		throw new Error(`Network response was not ok: ${response.status}`);
	}

	const result: IndexaPlansSummaryResponse = await response.json();
	return result;
}
